import { Timeframe } from './types';

export const PAGINATION_SIZE = 5;
export const FIRST_PAGE_SIZE = PAGINATION_SIZE * 2;

export const FOR_YOU_PAGE_SIZE = 3;
export const FOR_YOU_PAGE_WITH_LOOM_SIZE = 2;

export const LOOM_SLICE_INS = [1, 5];
export const LOOM_GRID_SIZE = 4;

export const TAB_QUERY_PARAM = 'tab';

export const LABELS_IN_TABS = ['welcome-blog', 'farewell-blog'];

// This map is for the `confluence_search` GraphQL endpoint.
export const timeframeMap: Record<Timeframe, string> = {
  day: '-1d',
  week: '-1w',
  default: '-2w',
  month: '-30d',
  year: '-1y',
};
